import { ValidationObserver, ValidationProvider } from "vee-validate/dist/vee-validate.full";
import * as firebase from "firebase/app";
import { getRegionName } from '@/utils/functionsRegion';

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: ["eventId"],
  data() {
    return {
      externalDialog: false,
      verifying: false,
      password: ""
    };
  },
  created() {
    if (!this.$route.meta.requiresAuth) {
      this.externalDialog = true
    }
  },
  methods: {
    async verifyPassword() {
      this.verifying = true;
      this.$refs.observer.validate();
      firebase.app().functions(getRegionName())
        .httpsCallable("verifyExternalHostPasscode")({
          eventId: this.eventId,
          passcode: this.password
        })
        .then(snap => {
          if (snap.data === true) {
            this.externalDialog = false;
          }
          else {
            this.$refs.observer.setErrors({
              password: ["Password not correct!"]
            });
          }
          this.$emit("onPassCodeCheck", snap.data);
        }).finally(()=>{
          this.verifying = false;
        });
    }
  }
};
